import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  infoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: {
      xs: '10px',
      md: '16px',
    },
  },
  labelChipsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: {
      xs: '6px',
      md: '10px',
    },
  },
  chips: {
    height: '32px',
    padding: {
      xs: '6px 10px',
      md: '8px 16px',
    },
    fontSize: '14px',
    cursor: 'default',
    backgroundColor: 'neutral.white',
    gap: '8px',
    borderColor: 'rgba(0,0,0,0.2)',
    color: 'grey.600',
  },
  cardWrapper: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      sm: 'unset',
    },
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: {
      xs: '16px',
      md: '24px',
    },
    flexBasis: { xs: '100%', md: '80%' },
  },
  featureCardWrapperLink: {
    width: '100%',
  },
  featureCardWrapper: {
    alignItems: 'center',
    flex: 1,
    flexBasis: {
      xs: '100%',
      sm: 'calc(50% - 12px)',
      md: 'calc(30% - 12px)',
      lg: 'calc(20% - 16px)',
    },
    maxWidth: {
      xs: '100%',
      sm: 'unset',
    },
    minWidth: {
      xs: '100%',
      sm: 'unset',
    },
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
